import { getLast, gte, size } from 'junctions-fp'

/**
 * history manager
 */
export default class HistoryManager {
  /**
   * crée une instance de HistoryManager.
   * @param {*} target la référence a l'intance editor
   * @memberof HistoryManager
   */
  constructor(target) {
    this.target = target
    this._commandList = []
    this._stateHistory = [this._getSnapShot()]
    this.historySize = 50
  }
  /**
   * Ajoute une commande a la liste des commandes
   *
   * @param {*} command
   * @memberof HistoryManager
   */
  add(command) {
    this._commandList = [...this._commandList, command]
  }

  /**
   * Ecécute l'ensemble des commandes ajouter
   *
   * @memberof HistoryManager
   */
  execute() {
    this._commandList.forEach(command => command.execute())
    this._commandList = []
    this._insertHistory()
  }

  /**
   *Appeler pour forcer un snapshot (appeler par pixeleditor lors d'une transformation d'un objet de type, scale, rotate, move etc...)
   *
   * @memberof HistoryManager
   */
  forceSnap() {
    this._insertHistory()
  }
  /**
   * Supprime le dernier snapshot et charge dans le canvas le précédent snapshot.
   *
   * @memberof HistoryManager
   */
  undo() {
    if (this._stateHistory.length > 0) {
      this._stateHistory.pop()
      this._commandList.pop()
      const lastSnapShot = getLast(this._stateHistory)
      this.target.canvas.loadFromDatalessJSON(lastSnapShot, () => {
        this.target.grid.updateLayer(this.target)
        this.target._draw()
      })
    }
  }
  /**
   *  Insert un snapshot du canvas.
   * Si la taille de l'historique est >= a la taille de la liste d'historique
   * alors on supprime le premier élément de la liste d'historique avant d'insérer le snapshot
   * @private
   * @memberof HistoryManager
   */
  _insertHistory() {
    if (gte(this.historySize, size(this._stateHistory))) {
      this._stateHistory.shift()
    }
    this._stateHistory = [...this._stateHistory, this._getSnapShot()]
  }
  /**
   * Récupère la list des commandes
   *
   * @readonly
   * @memberof HistoryManager
   */
  get history() {
    return this._commandList
  }

  /**
   * Crée un snapshot du canvas
   * @private
   * @returns un JSON du canvas
   * @memberof HistoryManager
   */
  _getSnapShot() {
    return this.target.canvas.toDatalessJSON(['uid', 'isLogo', 'subtype', 'layer'])
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/HitoryManager.js